import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import {
  HdsButton,
  HdsButtonSet,
} from '@hashicorp/design-system-components/components';

const Footer = <template>
  <HdsButtonSet>
    <HdsButton
      @text={{@buttonText}}
      type="submit"
      form={{@formId}}
      data-test-mfa-primary
    />
    {{#unless @hideCancel}}
      <HdsButton
        @color="secondary"
        @text={{t "components.form.cancel"}}
        {{on "click" @close}}
        data-test-mfa-secondary
      />
    {{/unless}}
  </HdsButtonSet>
</template>;

export default Footer;
